<template>
  <div>
    <Modal :show="showModal">
    <template #header> Verify your phone number </template>
    <template #body>
      <form @submit.prevent="sendVerificationCode">
        <label> Enter in your phone number </label>
        <input type="text" v-model="phoneNumber" />
        <button id="submitPhoneNumberBtn">Submit</button>
        <p>{{ error }}</p>
      </form>
      <form @submit.prevent="confirmVerificationcode">
        <label> Enter in the code </label>
        <input v-model="verificationCode" type="text" />
        <button>Submit</button>
        <p>{{ error2 }}</p>
      </form>
    </template>
    <template #footer>Texavie</template>
  </Modal>
  <div>
    <span>Other sign in options:</span>
    <ul class="iq-social-media">
    <li v-for="(socialProvider, index) in socialProviders" :key="index">
      <a href="javascript:void(0)" @click="socialLogin(socialProvider.type)">
        <i :class="socialProvider.icon"></i>
      </a>
    </li>
  </ul>
  </div>
  </div>
</template>

<script>
// import firebase from 'firebase'
import firebaseService from '../../../../../firebase'
import Modal from '../../../../components/Modal.vue'

import {
  OAuthProvider,
  signInWithPopup,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  deleteUser,
  fetchSignInMethodsForEmail, linkWithCredential, getAuth, signInWithEmailAndPassword
} from 'firebase/auth'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { httpsCallable } from 'firebase/functions'

export default {
  name: 'SocialLoginForm',
  components: { Modal },
  setup () {
    const provider = new OAuthProvider('apple.com')
    const addDoctorClaim = httpsCallable(firebaseService.functions, 'addDoctorClaim')

    const socialProviders = [
      {
        type: 'google',
        icon: 'ri-google-fill'
      },
      {
        type: 'apple',
        icon: 'ri-apple-fill'
      },
      {
        type: 'phone',
        icon: 'ri-phone-fill'
      },
      {
        type: 'azure',
        icon: 'ri-windows-fill'
      }
    ]
    const showModal = ref(false)
    const verificationCode = ref(null)
    const phoneNumber = ref(null)
    const error = ref(null)
    const error2 = ref(null)
    const router = useRouter()
    let authObject = null

    const socialLogin = (type) => {
      let provider

      if (type === 'google') {
        provider = new OAuthProvider('google.com')
      } else if (type === 'apple') {
        provider = new OAuthProvider('apple.com')
      } else if (type === 'phone') {
        showModal.value = true
        return
      } else if (type === 'azure') {
        provider = new OAuthProvider('oidc.azure')
      } else {
        console.log('Unsupported provider type')
        return
      }

      signInWithPopup(firebaseService.firebaseAuth, provider)
        .then(async (result) => {
          const user = result.user
          const ref = doc(firebaseService.db, 'users', user.uid)
          const userSnapshot = await getDoc(ref)

          if (!userSnapshot.exists()) {
            await setDoc(ref, {
              firstName: user.displayName,
              lastName: user.displayName,
              email: user.email
            })
            router.push('/customer/preorders')
          } else if (userSnapshot.data().isAuthorized) {
            router.push('/patient-home')
          } else {
            router.push('/customer/preorders')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }

    const sendVerificationCode = async () => {
      const applicationVerifier = new RecaptchaVerifier(
        'submitPhoneNumberBtn',
        { size: 'invisible' },
        firebaseService.firebaseAuth
      )
      try {
        authObject = await signInWithPhoneNumber(
          firebaseService.firebaseAuth,
          '+1' + phoneNumber.value,
          applicationVerifier
        )
        error.value = 'Code sent'
      } catch (err) {
        console.log(err)
        error.value = 'There was an error. Try again signing up again.'
      }
    }
    const confirmVerificationcode = async () => {
      try {
        const userCredentials = await authObject.confirm(
          verificationCode.value.toString()
        )
        const ref = doc(
          firebaseService.db,
          'doctors',
          userCredentials.user.uid
        )
        const docSnapshot = await getDoc(ref)
        if (!docSnapshot.exists()) {
          deleteUser(userCredentials.user)
          alert(
            "You don't have an account with this phone number, please register it"
          )
          router.push('/auth/sign-up1')
        } else {
          await addDoctorClaim({ uid: userCredentials.user.uid })
          router.push('/')
        }
      } catch (err) {
        console.log(err)
        error2.value = 'There was an error. Try again later.'
      }
    }

    const saveDoctorInfo = async (user) => {
      const ref = doc(firebaseService.db, 'doctors', user.uid)
      const docSnapshot = await getDoc(ref)
      const names = user.displayName.split(' ')
      if (!docSnapshot.exists()) {
        await setDoc(
          doc(firebaseService.db, 'doctors', user.uid),
          {
            firstName: names[0],
            lastName: names.length > 1 ? names[1] : names[0],
            patients: []
          }
        )
      }
    }
    return {
      socialProviders,
      showModal,
      verificationCode,
      phoneNumber,
      error,
      error2,
      socialLogin,
      sendVerificationCode,
      confirmVerificationcode
    }
  }
}
</script>

<style>
.iq-social-media {
  float: none !important;
  margin-top: 5px !important;
}
</style>
